import usePersistUser from '@modules/core/hooks/usePersistUser';
import paymentsApi from '@modules/payments/api';
import { useQuery } from '@tanstack/react-query';

const useGetBillingPortal = (enabled: boolean) => {
  const { user } = usePersistUser();

  const { isLoading, data, error } = useQuery({
    queryKey: ['paymentsBillingPortal'],
    queryFn: () => paymentsApi.getBillingPortal(user?.brokerageId!),
    staleTime: 60 * 10, // 10 minutes
    retry: 2,
    enabled,
  });

  return {
    fetch,
    data,
    isLoading,
    error,
  };
};

export { useGetBillingPortal };
